import fields from '../../admin/views/newOffer/fields.json';

export const service_catalog_items = () => {
    return Object.entries(fields).flatMap(([typeName, services]) => {
        return Object.entries(services)
            .filter(([serviceName]) => serviceName !== 'overview')
            .flatMap(([serviceName, serviceValue]) => {
                if ('status' in serviceValue) {
                    return [{
                        serviceKey: `${typeName}_${serviceName}`,
                        serviceName,
                        sourceType: typeName,
                        catalogType: serviceValue.catalog_type || typeName,
                        serviceValue
                    }];
                }

                return Object.entries(serviceValue).map(([nestedName, nestedValue]) => ({
                    serviceKey: `${typeName}_${serviceName}_${nestedName}`,
                    serviceName: `${serviceName} / ${nestedName}`,
                    sourceType: typeName,
                    catalogType: nestedValue.catalog_type || typeName,
                    serviceValue: nestedValue
                }));
            });
    });
};
